import { useMutation } from 'react-query'
import { putAPI } from 'framework/api/http'

interface UpdateOrderLineByIdInterface {
  partnerOrderId?: string
  orderLineId?: string
  warehouseSKU?: string
  totalPrice?: string
}

export const useUpdateOrderLineById = () => {
  const mutate = useMutation(
    ({
      partnerOrderId,
      orderLineId,
      warehouseSKU,
      totalPrice,
    }: UpdateOrderLineByIdInterface) => {
      console.log(totalPrice)
      return putAPI(
        `/PartnerOrders/${partnerOrderId}/OrderLines/${orderLineId}`,
        {
          warehouseSKU: warehouseSKU,
          totalPrice: totalPrice,
        },
      )
    },
  )

  return mutate
}

export default useUpdateOrderLineById
